(() => {
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-htl-variant-id]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.dataset.htlAdding === 'true') return;
    link.dataset.htlAdding = 'true';
    link.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: link.dataset.htlVariantId, quantity: Number(link.dataset.htlQuantity || 1) }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product to your basket.');
      window.location.assign(root + 'cart');
    } catch (error) {
      window.alert(error.message || 'Unable to add this product to your basket. Please try again.');
      delete link.dataset.htlAdding;
      link.removeAttribute('aria-busy');
    }
  });
})();
